import PeopleContactsReducer, {
  Actions as PeopleContactsActions,
  initialState as initialPeopleContactsState,
  PeopleContactsState,
} from 'src/app/PeopleContacts/redux/peopleContacts.reducer'
import PeopleInvitedToOrgReducer, {
  Actions as PeopleInvitedToOrgActions,
  initialState as initialPeopleInvitedToOrgState,
  PeopleInvitedToOrgState,
} from 'src/app/PeopleInvitedToOrg/redux/peopleInvitedToOrg.reducer'
import PeopleMembersReducer, {
  Actions as PeopleMembersActions,
  initialState as initialPeopleMembersState,
  PeopleMembersState,
} from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import PeopleOwnersAndAdminsReducer, {
  Actions as PeopleOwnersAndAdminsActions,
  initialState as initialPeopleOwnersAndAdminsState,
  PeopleOwnersAndAdminsState,
} from 'src/app/PeopleOwnersAndAdmins/redux/peopleOwnersAndAdmins.reducer'

export type PeopleState = {
  peopleMembers: PeopleMembersState
  peopleContacts: PeopleContactsState
  peopleInvitedToOrg: PeopleInvitedToOrgState
  peopleOwnersAndAdmins: PeopleOwnersAndAdminsState
}

export const initialState: PeopleState = {
  peopleMembers: initialPeopleMembersState,
  peopleContacts: initialPeopleContactsState,
  peopleInvitedToOrg: initialPeopleInvitedToOrgState,
  peopleOwnersAndAdmins: initialPeopleOwnersAndAdminsState,
}

export type Actions =
  | PeopleMembersActions
  | PeopleContactsActions
  | PeopleInvitedToOrgActions
  | PeopleOwnersAndAdminsActions

const PeopleReducer = (state = initialState, action: Actions): PeopleState => ({
  peopleMembers: PeopleMembersReducer(
    state.peopleMembers,
    action as PeopleMembersActions,
  ),
  peopleContacts: PeopleContactsReducer(
    state.peopleContacts,
    action as PeopleContactsActions,
  ),
  peopleInvitedToOrg: PeopleInvitedToOrgReducer(
    state.peopleInvitedToOrg,
    action as PeopleInvitedToOrgActions,
  ),
  peopleOwnersAndAdmins: PeopleOwnersAndAdminsReducer(
    state.peopleOwnersAndAdmins,
    action as PeopleOwnersAndAdminsActions,
  ),
})

export default PeopleReducer
